export const DefaultFields = {
	ESTIMATE: 'estimate',
	PRIORITY: 'priority',
	PRECONDITIONS: 'preconditions',
	STEPS: 'steps',
	AUTOMATED: 'automated',
};

export type DefaultFields = keyof typeof DefaultFields;
